import { useLocation } from 'react-router-dom';

const useQuery = ()=> {
    return new URLSearchParams(useLocation().search);
};

export const getReturnUrl = ()=>{
    const query = useQuery();
    const parameter = query.get('ReturnUrl');
    return encodeURIComponent(parameter ?? '');
};